import { getUserZppCourseAttendances } from 'redux/query';
import { getCurrentEntryContent } from 'reducers/index';
import { TEXT } from 'locales/translations';

export const getCourseButtonText = (state) => {
  const zppCourses = getUserZppCourseAttendances(state);
  const entryContent = getCurrentEntryContent(state);

  const isZppCourse = zppCourses.some((course) => entryContent?.id === course?.courseId);

  if (isZppCourse) {
    return TEXT.courseTeaser.button.toCourse;
  }

  if (state.entities.entryContent.headingKey === 'LAST_LISTENED') {
    return TEXT.courseTeaser.button.continueCourse;
  }
  return TEXT.courseTeaser.button.startCourse;
};
